module.exports = __webpack_public_path__ + "static/media/ic_searchtype_bay.9def2eec.svg";